export const ProjectSettingsTab = {
    PROJECT_CATEGORY: 0,
    PROJECT_RESOURCE_TYPE: 1,
    TASK_CATEGORY: 2
}